<template>
  <div class="TasksCloseButton" @click="closeModal">
    <button>
      <IconClose />
    </button>
  </div>
</template>

<script>
import IconClose from "../../../ELYXIcons/IconClose.vue";
import { ELYXCentralStore } from "../../../ELYX/ELYXStore";
import TasksStore from "./TasksStore.js";

export default {
  components: {
    IconClose,
  },
  methods: {
    closeModal() {
      ELYXCentralStore.methods.closeModal();
      TasksStore.methods.closeTasks();
    },
  },
};
</script>

<style scoped>
.TasksCloseButton {
  border-radius: 360px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 15px;
  top: 10px;
  box-sizing: border-box;
  padding: 4px;
  /* background-color: rgb(255 255 255); */
}

.TasksCloseButton:hover {
  background-color: rgb(255 255 255);
  box-shadow: 0 0 0 1px rgb(15 15 15 / 5%), 0 3px 6px rgb(15 15 15 / 10%), 0 9px 24px rgb(213 213 213 / 20%);
}

.TasksCloseButton button {
  background-color: transparent;
  border: none;
  display: flex;
  width: 24px;
  height: 24px;
  padding: 6.5px;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.TasksCloseButton--shrinkedView {
  position: unset;
  top: unset;
  right: unset;
  margin-left: auto;
  padding: 6px;
}

/* For some reason, Firefox displays the icons bigger than other browsers */
@supports (-moz-appearance: none) {
  .TasksCloseButton button {
    width: 20px;
    height: 20px;
  }
}
</style>
